/**
 * Siatka tabeli „Historia paczek", wspólna dla `ChangeHistoryTable` i jej
 * szkieletu. Kolumny: paczka / stan / data / wpływ.
 */
export const changeHistoryGridClass =
  'grid grid-cols-[160px_1fr_200px_150px] px-7';
